const initFilterState = {
  merk: [],
  seri: [],
  tipe: [],
  silinder: [],
  dari_tahun: [],
  sampai_tahun: [],
  periode_data: [],
  kota: [],
  transmisi: [],
};

export const filterReducer = (state = initFilterState, action) => {
  if (action.type == 'SET_MERK') {
    return {
      ...state,
      merk: action.value,
    };
  }
  if (action.type == 'SET_SERI') {
    return {
      ...state,
      tipe: action.value,
    };
  }
  if (action.type == 'SET_TIPE') {
    return {
      ...state,
      tipe: action.value,
    };
  }
  if (action.type == 'SET_SILINDER') {
    return {
      ...state,
      silinder: action.value,
    };
  }
  if (action.type == 'SET_DARI_TAHUN') {
    return {
      ...state,
      dari_tahun: action.value,
    };
  }
  if (action.type == 'SET_SAMPAI_TAHUN') {
    return {
      ...state,
      sampai_tahun: action.value,
    };
  }
  if (action.type == 'SET_PERIODE_DATA') {
    return {
      ...state,
      periode_data: action.value,
    };
  }
  if (action.type == 'SET_KOTA') {
    return {
      ...state,
      kota: action.value,
    };
  }
  if (action.type == 'SET_TRANSMISI') {
    return {
      ...state,
      transmisi: action.value,
    };
  }
  if (action.type == 'SET_WARNA') {
    return {
      ...state,
      warna: action.value,
    };
  }
  if (action.type == 'SET_KEPEMILIKAN') {
    return {
      ...state,
      kepemilikan: action.value,
    };
  }
  if (action.type == 'SET_KOTA') {
    return {
      ...state,
      kota: action.value,
    };
  }
  if (action.type == 'SET_ISSTNK') {
    return {
      ...state,
      isStnk: action.value,
    };
  }
  if (action.type == 'SET_MODEL') {
    return {
      ...state,
      model: action.value,
    };
  }

  return state;
};
